<script setup>
import { onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const route = useRoute();
const router = useRouter();

onMounted(() => {
  const { code, state, error } = route.query;

  try {
    const { accountId } = JSON.parse(atob(state || ''));
    const base = `/app/accounts/${accountId}/settings/integrations/akiles`;

    if (code) {
      router.replace(`${base}?code=${encodeURIComponent(code)}`);
    } else {
      router.replace(`${base}?error=${encodeURIComponent(error || 'unknown')}`);
    }
  } catch {
    router.replace('/app/login');
  }
});
</script>

<template>
  <div />
</template>
